import React, { Fragment } from "react";
import styled from "styled-components";
import { IC } from "../../resources/Assets";

const CardEmpty = () => {
  return (
    <Fragment>
      <ContentImage src={IC.card.ICON_CARD_GRAY} />
      <TextTitle>등록된 카드가 없어요</TextTitle>
      <TextDesc>
        결제수단 추가를 통해 카드를 등록하고 <br /> 접수를 진행해 주세요
      </TextDesc>
    </Fragment>
  );
};

const ContentImage = styled.img`
  width: 64px;
  height: 64px;
  flex-grow: 0;
  padding: 11.6px 5.3px 11px 5.3px;
`;

const TextTitle = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  text-align: center;
  color: #333;
`;

const TextDesc = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: center;
  color: #888;
`;

export default CardEmpty;
